<template>
  <section class="dp-layout home-visit-config-page">
    <section class="dp-left">
      <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1"></DepartmentPane>
    </section>
    <section class="dp-right config-page-right">
      <toolbar :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>

      <div v-if="!schoolId" class="empty-tip">
        <div class="empty-tip-inner">
          <i class="el-icon-school empty-icon"></i>
          <p class="empty-title">尚未选择学校</p>
          <p class="empty-desc">请从左侧机构树选择学校节点后再配置家访</p>
        </div>
      </div>

      <div v-else class="config-panel" v-loading="loading">
        <div class="config-top-bar">
          <div class="org-display-card">
            <i class="el-icon-office-building org-icon"></i>
            <span class="org-label">当前学校：</span>
            <span class="org-value">{{ currentSchoolName || "—" }}</span>
          </div>
          <el-button
            type="primary"
            icon="el-icon-check"
            :loading="saving"
            :disabled="!schoolId"
            @click="saveConfig"
          >保存配置</el-button>
        </div>

        <div class="setting-grid">
          <div class="setting-card setting-card--access">
            <header class="setting-card-head">
              <span class="setting-card-icon setting-card-icon--access"><i class="el-icon-s-custom"></i></span>
              <div class="setting-card-head-text">
                <span class="setting-card-name">教师选班范围</span>
                <span class="setting-card-sub">控制手机端教师可家访的班级范围</span>
              </div>
            </header>
            <div class="setting-row">
              <div class="setting-row-text">
                <div class="setting-row-label">全校教师可选任意行政班</div>
                <div class="setting-row-desc">
                  开启后，本校任意教师可在 H5 自由切换全校行政班选学生家访；关闭时仅能在本人任教（含班主任）的班级家访
                </div>
              </div>
              <el-switch v-model="configForm.allowSchoolWideClassSelect" class="setting-row-switch"></el-switch>
            </div>
          </div>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import DepartmentPane from "../../components/DepartmentPane";
import Toolbar from "../../components/Toolbar";
import { getButtonList } from "../../promissionRouter";
import { invokeToolbarMethod } from "@/api/classCircle";
import {
  getHomeVisitConfig,
  saveHomeVisitConfig,
  resolveHomeVisitSchoolIdFromTreeNode
} from "@/api/homeVisit";

const schoolLikeTypes = ["school", "campus", "affiliateschool"];

function emptyConfig(schoolId) {
  return {
    schoolId: schoolId || 0,
    allowSchoolWideClassSelect: false
  };
}

/** 从树节点解析学校展示名 */
function pickSchoolDisplayName(node, data) {
  let n = node;
  while (n && n.data) {
    const t = String(n.data.DeptOrgType != null ? n.data.DeptOrgType : n.data.deptOrgType || "").toLowerCase();
    if (schoolLikeTypes.includes(t)) {
      return n.data.label || n.data.name || "";
    }
    n = n.parent;
  }
  return (data && (data.label || data.name)) || "";
}

export default {
  components: { DepartmentPane, Toolbar },
  data() {
    return {
      searchList: [],
      buttonList: [],
      DepartmentId: 0,
      schoolId: 0,
      currentSchoolName: "",
      configForm: emptyConfig(0),
      loading: false,
      saving: false
    };
  },
  mounted() {
    const routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
  methods: {
    callFunction(item) {
      if (!invokeToolbarMethod(this, item)) {
        const funcName = item && (item.Func || item.func);
        if (funcName) this.$message.warning("按钮「" + (item.name || funcName) + "」暂未实现");
      }
    },
    handleQuery() {
      this.loadConfig();
    },
    handleAdd() {
      this.saveConfig();
    },
    handleEdit() {
      this.saveConfig();
    },
    handleDel() {
      this.$message.info("配置页不支持删除操作");
    },
    treeNodeClick(data, node) {
      this.DepartmentId = data.value;
      this.schoolId = resolveHomeVisitSchoolIdFromTreeNode(node, data.value);
      this.currentSchoolName = pickSchoolDisplayName(node, data);
      this.loadConfig();
    },
    async loadConfig() {
      if (!this.schoolId) {
        this.configForm = emptyConfig(0);
        this.currentSchoolName = "";
        return;
      }
      this.loading = true;
      try {
        const res = await getHomeVisitConfig(this.schoolId);
        if (res.data.success && res.data.response) {
          const r = res.data.response;
          this.configForm = {
            schoolId: r.schoolId || r.SchoolId || this.schoolId,
            allowSchoolWideClassSelect: !!(r.allowSchoolWideClassSelect != null
              ? r.allowSchoolWideClassSelect
              : r.AllowSchoolWideClassSelect)
          };
        } else {
          this.configForm = emptyConfig(this.schoolId);
          this.$message.error(res.data.msg || "加载配置失败");
        }
      } finally {
        this.loading = false;
      }
    },
    async saveConfig(item) {
      if (!this.schoolId) {
        this.$message.warning("请先选择学校");
        return;
      }
      this.saving = true;
      if (item) item.loading = true;
      try {
        const payload = Object.assign({}, this.configForm, { schoolId: this.schoolId });
        const res = await saveHomeVisitConfig(payload);
        if (res.data.success) {
          this.$message.success(res.data.msg || "保存成功");
        } else {
          this.$message.error(res.data.msg || "保存失败");
        }
      } finally {
        this.saving = false;
        if (item) item.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.home-visit-config-page {
  min-height: 0;
}

.config-page-right {
  display: flex;
  flex-direction: column;
  min-width: 0;
  min-height: 0;
}

.config-panel {
  flex: 1;
  min-width: 0;
  min-height: 0;
  width: 100%;
  margin-top: 4px;
  padding-bottom: 28px;
  overflow: auto;
}

.config-top-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 20px;
}

.config-top-bar .org-display-card {
  margin-bottom: 0;
}

.setting-grid {
  display: grid;
  grid-template-columns: minmax(300px, 480px);
  gap: 16px;
  align-items: start;
}

.org-display-card {
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
  padding: 10px 16px;
  background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
  border: 1px solid #bfdbfe;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.06);
  font-size: 14px;
  line-height: 1.4;
}

.org-icon {
  color: #3b82f6;
  font-size: 16px;
  margin-right: 4px;
}

.org-label {
  color: #1e3a8a;
  font-weight: 500;
}

.org-value {
  color: #2563eb;
  font-weight: 600;
  word-break: break-all;
}

.setting-card {
  margin-bottom: 0;
  background: #fff;
  border-radius: 12px;
  border: 1px solid #e8ecf1;
  box-shadow: 0 2px 12px rgba(15, 23, 42, 0.04);
  overflow: hidden;
  transition: box-shadow 0.2s ease, border-color 0.2s ease;
}

.setting-card:hover {
  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.06);
}

.setting-card--access {
  border-top: 3px solid #e6a23c;
}

.setting-card-head {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 18px 12px;
  background: linear-gradient(180deg, #fafbfc 0%, #fff 100%);
  border-bottom: 1px solid #f0f2f5;
}

.setting-card-icon {
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
}

.setting-card-icon--access {
  background: #fdf6ec;
  color: #e6a23c;
}

.setting-card-head-text {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.setting-card-name {
  font-size: 15px;
  font-weight: 600;
  color: #303133;
  line-height: 1.35;
}

.setting-card-sub {
  font-size: 12px;
  color: #909399;
  line-height: 1.4;
}

.setting-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
  padding: 14px 18px;
}

.setting-row-text {
  flex: 1;
  min-width: 0;
  padding-top: 2px;
}

.setting-row-label {
  font-size: 14px;
  color: #303133;
  font-weight: 500;
  line-height: 1.45;
}

.setting-row-desc {
  margin-top: 4px;
  font-size: 12px;
  color: #909399;
  line-height: 1.55;
}

.setting-row-switch {
  flex-shrink: 0;
  margin-top: 2px;
}

.empty-tip {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 280px;
  padding: 24px;
}

.empty-tip-inner {
  text-align: center;
  max-width: 280px;
}

.empty-icon {
  font-size: 48px;
  color: #dcdfe6;
}

.empty-title {
  margin: 12px 0 6px;
  font-size: 15px;
  font-weight: 500;
  color: #606266;
}

.empty-desc {
  margin: 0;
  font-size: 13px;
  color: #909399;
  line-height: 1.55;
}
</style>
